// Mirrors AdTargetingCategory enum from avocash-ads. This is the primary
// targeting axis shown to advertisers — most campaigns are built by
// picking one or more of these rather than raw group categories/types.

export const AD_TARGETING_CATEGORIES = [
  { group: 'ad.targeting.group.consumption', items: [
    { code: 'FOOD__CATERING',        label: 'ad.targeting.foodCatering' },
    { code: 'FASHION__FABRIC',       label: 'ad.targeting.fashionFabric' },
    { code: 'HOME__DECOR',           label: 'ad.targeting.homeDecor' },
    { code: 'EVENTS__PHOTOGRAPHY',   label: 'ad.targeting.eventsPhotography' },
    { code: 'EVENTS__VENUE',         label: 'ad.targeting.eventsVenue' },
    { code: 'GIFTS__PERSONALISED',   label: 'ad.targeting.giftsPersonalised' },
  ]},
  { group: 'ad.targeting.group.financialServices', items: [
    { code: 'FINTECH__MOBILE_MONEY',  label: 'ad.targeting.mobileMoney' },
    { code: 'FINTECH__MICROFINANCE',  label: 'ad.targeting.microfinance' },
    { code: 'FINTECH__REMITTANCE',    label: 'ad.targeting.remittance' },
    { code: 'INSURANCE__HEALTH',      label: 'ad.targeting.insuranceHealth' },
    { code: 'INSURANCE__LIFE_FUNERAL',label: 'ad.targeting.insuranceLifeFuneral' },
    { code: 'BANKING__BUSINESS',      label: 'ad.targeting.bankingBusiness' },
  ]},
  { group: 'ad.targeting.group.educationEmployment', items: [
    { code: 'EDUCATION__SUPPLIES',       label: 'ad.targeting.educationSupplies' },
    { code: 'EDUCATION__CERTIFICATION',  label: 'ad.targeting.educationCertification' },
    { code: 'EMPLOYMENT__RECRUITMENT',   label: 'ad.targeting.employmentRecruitment' },
  ]},
  { group: 'ad.targeting.group.healthWellness', items: [
    { code: 'HEALTH__PHARMACY', label: 'ad.targeting.healthPharmacy' },
    { code: 'HEALTH__FITNESS',  label: 'ad.targeting.healthFitness' },
  ]},
  { group: 'ad.targeting.group.techTelecoms', items: [
    { code: 'TECH__TELECOMS',           label: 'ad.targeting.techTelecoms' },
    { code: 'TECH__ELECTRONICS',        label: 'ad.targeting.techElectronics' },
    { code: 'TECH__BUSINESS_SOFTWARE',  label: 'ad.targeting.techBusinessSoftware' },
  ]},
  { group: 'ad.targeting.group.agricultureTrade', items: [
    { code: 'AGRICULTURE__INPUTS', label: 'ad.targeting.agricultureInputs' },
    { code: 'AGRICULTURE__MARKET', label: 'ad.targeting.agricultureMarket' },
  ]},
  { group: 'ad.targeting.group.realEstateTransport', items: [
    { code: 'REAL_ESTATE__RENTAL',  label: 'ad.targeting.realEstateRental' },
    { code: 'TRANSPORT__DELIVERY',  label: 'ad.targeting.transportDelivery' },
  ]},
  { group: 'ad.targeting.group.mediaEntertainment', items: [
    { code: 'ENTERTAINMENT__EVENTS',  label: 'ad.targeting.entertainmentEvents' },
    { code: 'ENTERTAINMENT__DIGITAL', label: 'ad.targeting.entertainmentDigital' },
  ]},
  { group: 'ad.targeting.group.solidarity', items: [
    { code: 'SOLIDARITY__FUNDRAISING',     label: 'ad.targeting.solidarityFundraising' },
    { code: 'SOLIDARITY__CSR_SPONSORSHIP', label: 'ad.targeting.solidarityCsrSponsorship' },
  ]},
]

export const ALL_AD_TARGETING_CATEGORIES = AD_TARGETING_CATEGORIES.flatMap(g => g.items)

export function adCategoryLabel(code) {
  return ALL_AD_TARGETING_CATEGORIES.find(c => c.code === code)?.label ?? code
}